import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-four-element',
  templateUrl: './four-element.component.html',
  styleUrls: ['./four-element.component.css']
})
export class FourElementComponent implements OnInit {

  hide_resources_text = true;
  hide_enterdata_text = false;
  hide_seedata_text = true;
  hide_reporting_text = true;
  img : string;

  constructor() { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".intro-four").addClass("header_active")
    if(window.location.href.indexOf("/ko/")>-1){
      this.img="./assets/img/samplechart_ko.png";
    }
    else if (window.location.href.indexOf("/ar/")>-1){
      this.img="./assets/img/samplechart_ar.png"
    }
    else{
      this.img="./assets/img/samplechart.png";
    }
  }

  hide_all() {
    this.hide_resources_text = true;
    this.hide_enterdata_text = true;
    this.hide_seedata_text = true;
    this.hide_reporting_text = true;
  }

  show_resources_text() {
    this.hide_all();
    this.hide_resources_text = false;
  }

  show_enterdata_text() {
    this.hide_all();
    this.hide_enterdata_text = false;
  }

  show_seedata_text() {
    this.hide_all();
    this.hide_seedata_text = false;
  }

  show_reporting_text() {
    this.hide_all();
    this.hide_reporting_text = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/introduction/four-element/four-element.component.ts